<template>
    <div class="Part Statistics Overview" v-if="viewData.config.settings?.target">
        <ul class="block-grid three-up color-grid">
            <li v-for="item in viewData.config.settings.target.statistic_columns">
                <WorkflowstatisticItem :item="item"/>
            </li>
        </ul>
    </div>
</template>

<script>
import {defineComponent, inject, computed } from "vue";
import {useRoute} from "vue-router";

import Icon from "components/icon";
import trans from "helpers/_translation";

import WorkflowstatisticItem from "view/dashboard/includes/workflowstatistic-item";

export default defineComponent({
    name: "part",
    components: {
        Icon,
        WorkflowstatisticItem
    },
    setup() {
        const route = useRoute();
        const viewData = inject("viewData");

        return {
            trans,
            route,
            viewData
        }
    }
});
</script>